import React from 'react';

const Health = () => {
  return (
    <svg width='48' height='40' viewBox='0 0 48 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1091 27.1993C18.8574 33.6322 25.9954 38 25.9954 38C25.9954 38 46 25.7592 46 12.0807C46 6.51353 40.9989 2 35.9977 2C29.5677 2 25.9954 7.76079 25.9954 7.76079C25.9954 7.76079 21.7087 2.00187 15.9931 2.00094C10.2775 2 5.99076 6.51379 5.9908 12.0807C5.99082 15.0662 6.94385 17.9833 8.43387 20.7195M2 20.7195H16.7076L20.9943 14.2397L26.7099 24.3194L29.5677 17.8396H34.5689'
        stroke='#029AE7'
        stroke-width='3'
        stroke-linecap='round'
        stroke-linejoin='round'
      ></path>
    </svg>
  );
};

export default Health;
